import React, { useEffect, useRef, useState } from 'react';
import { createRoot } from 'react-dom/client';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import Artplayer from '../ArtPlayer';
import AudioPlayer, {
  ActiveUI,
  InterfaceGridTemplateArea,
  PlayerPlacement,
  PlayListPlacement,
  ProgressUI,
  VolumeSliderPlacement,
} from 'react-modern-audio-player';
import ButtomCustom from '../ButtonRound';
import ResponsiveIframe from '../ResponsiveIframe';
import OverlayLoader from '../OverlayLoader';
import parse from 'html-react-parser';
import * as download from 'downloadjs/download';
import { useSelector } from 'react-redux';
import { getMysqlDate } from '../../utils/generals';
import { getPathCourseResource, getBinaryContent } from '../../utils/electronFunctions';
import { useStateWithCallback } from '../../hooks/useStateWithCallback';
import HttpClient from '../../helpers/HttpClient'; 
import { getMimeType } from '../../utils/generals';
import { useInterval } from '../../hooks/useInterval'
import { ToastContainer } from 'react-toastify';
import { showToast } from '../../utils/toast';
import fileDownload from 'js-file-download';
import './styles.scss';

const Audio = ({ playList, getInstance }) => {
  const [progressType, setProgressType] = useState<ProgressUI>('waveform');
  const [playerPlacement, setPlayerPlacement] =
    useState<PlayerPlacement>('bottom-left');
  const [interfacePlacement, setInterfacePlacement] =
    useState<InterfaceGridTemplateArea>();
  const [playListPlacement, setPlayListPlacement] =
    useState<PlayListPlacement>('top');
  const [volumeSliderPlacement, setVolumeSliderPlacement] =
    useState<VolumeSliderPlacement>();
  const [theme, setTheme] = useState<'dark' | 'light' | undefined>();
  const [width, setWidth] = useState('100%');
  const [activeUI, setActiveUI] = useState<ActiveUI>({ all: true });

  const audioRef = useRef();

  useEffect(()=>{
    if (audioRef.current) {
      getInstance(audioRef.current)
    }
  }, [audioRef.current])

  return (
    <>
      <AudioPlayer
        playList={playList}
        activeUI={{
          ...activeUI,
          progress: progressType,
        }}
        audioRef={audioRef}
        placement={{
          interface: {
            templateArea: interfacePlacement,
          },

          volumeSlider: volumeSliderPlacement,
        }}
        rootContainerProps={{
          colorScheme: theme,
          width,
        }}
      />
    </>
  );
};

const Video = ({ source, subtitle, getInstance }) => {
  const subtitleSelector: any = [
    {
      html: "Ninguno",
    },
  ];
  if (subtitle) {
    subtitleSelector.push({
      html: "Subtítulo 1",
      url: subtitle,
      style: {
        color: "#fe9200",
        fontSize: "20px",
      },
      encoding: "utf-8",
    });

  }
  return (
    <div style={{height: "auto"}}>
      <Artplayer
        option={{
          settings:[{
            html: "Subtítulo",
            width: 250,
            tooltip: "Ninguno",
            selector: subtitleSelector,
            onSelect: function (item, $dom, event) {
              console.info(item, $dom, event);
              console.log(this)
              if (item.html == "Ninguno") {
                this.subtitle.show = false;
              } else {
                this.subtitle.show = true;
                this.subtitle.url = item.url;
              }
              // Change the tooltip
              return item.html;
            },
          }],
          id: source,
          url: source,
          setting: true,
          autoSize: false,
          autoMini: true,
          screenshot: true,
          loop: false,
          flip: true,
          playbackRate: true,
          aspectRatio: true,
          fullscreen: true,
          fullscreenWeb: true,
          miniProgressBar: true,
          mutex: true,
          backdrop: true,
          playsInline: true,
          autoPlayback: true,
          airplay: true,
          theme: '#23ade5',
          lang: 'es',
          whitelist: ['*'],
          moreVideoAttr: {
            crossOrigin: '*',
          },
        }}
        style={{
          maxWidth: '800px',
          height: '450px',
          margin: 'auto',
        }}
        getInstance={(art) => {
          getInstance(art)
        }}
      />
    </div>
  );
};

const ContentRenderer = ({ data, type, courseCode, onFinalize, onContinue }) => {
  const [html, setHtml] = useState(null);
  const [open, setOpen] = useState(false);
  const [filePathDownload, setFilePathDownload] = useState(null);
  const [rootMultimedia, setRootMultimedia] = useStateWithCallback([]);
  const [artPlayerInstances, setArtPlayerInstances] = useState([]);
  const [audiosInstances, setAudiosInstances] = useState([]);
  const authState = useSelector((state) => state.auth);
  const videosDuration = useRef(0);
  const audiosDuration = useRef(0);
  const DEFAULT_DURATION_SUBLESSONS_SECONDS = 30;
  const sublessonDuration = useRef(DEFAULT_DURATION_SUBLESSONS_SECONDS);
  const MAX_DURATION_VIDEOS_PERCENTAGE = 50;
  const MAX_DURATION_AUDIOS_PERCENTAGE = 50;

  const [count, setCount] = useState(0) 
  const [delay, setDelay] = useState(1000) 
  const [isPlaying, setPlaying] = useState(false)
  const durationFromDB = useRef(false)
  const isQuizFinalized = useRef(true);
  const [isSaved, setIsSaved] = useState(false)
  const [types, setTypes] = useState(["SUBLESSON", "LESSON"])

  useInterval( 
    () => { 
      setCount(count + 1) 
    },  
    isPlaying && !isSaved ? delay : null, 
  ) 

  const prepareHtml = async () => {
    setFilePathDownload(null);
    let path = "cursos/" + courseCode;
    let content = data.contenido;
    let content2 = "";
    sublessonDuration.current = DEFAULT_DURATION_SUBLESSONS_SECONDS;
    if (data.duracion_minima_segundos != null && Number(data.duracion_minima_segundos)){
      sublessonDuration.current = Number(data.duracion_minima_segundos);
      durationFromDB.current = true;
    }
     
    //imagenes
    const images = data.imagenes ? data.imagenes.split(',') : null;
    if (Array.isArray(images)) {
      for (let i = 0; i < images.length; i++) {
        let finalPath = '';
        if (images[i].indexOf("commons/") != -1){
          finalPath = await getPathCourseResource(
            images[i].replace("commons", "commons")
          );
        }else{
          finalPath = await getPathCourseResource(
            path + '/img/' + images[i]
          );
        }
        if (content){
          content = content.replace(images[i], finalPath);
        }else{
          content2 += "<img src='"+finalPath+"' />"
        }
      }
    }
    //interactivos 
    const interactives = data.interactivos ? data.interactivos.split(',') : null;
    
    if (Array.isArray(interactives)) {
      for (let i = 0; i < interactives.length; i++) {
        //let regex = /\n*\s*<iframe.*?\\?>.*?<\/iframe\\?>\s*\n*/gi;
        let regex = /\n*\s*<iframe.*?\\?>.*?<\/iframe\\?>\s*\n*/;
        if (content){
          content = content.replace(regex, "<div id='iframe_"+interactives[i]+"'></div>");
        }else{
          content2 += "<div id='iframe_"+interactives[i]+"'></div>"
        }
      }
    }
 
    if (!content){
      const videos = data.videos ? data.videos.split(',') : null;
      const audios = data.audios ? data.audios.split(',') : null;
      const iframe = data.interactivos ? data.interactivos.split(',') : null;
      if (Array.isArray(videos)) {
        for (let i = 0; i < videos.length; i++) {
          content2 += "<div id='"+videos[i]+"'></div>"
        }
      }

      if (Array.isArray(audios)) {
        for (let i = 0; i < audios.length; i++) {
          content2 += "<div id='"+audios[i]+"'></div>"
        }
      }

      if (Array.isArray(iframe)) {
        for (let i = 0; i < iframe.length; i++) {
          content2 += "<div id='iframe_"+iframe[i]+"'></div>"
        }
      }
    }

    if (data.archivo_descargable) {

      const arrayDownloadableFilesNames = data.archivo_descargable.split(",");
      const arrayDownloadableFilesButtonTexts = data.texto_boton.split(",");

      let newArrayFilesData = [];

      for (let k = 0; k < arrayDownloadableFilesNames.length; k++) {
        const extensionFile = arrayDownloadableFilesNames[k].split(".").pop();
        newArrayFilesData.push({
          file: path + '/descargables/' + arrayDownloadableFilesNames[k],
          buttonText: arrayDownloadableFilesButtonTexts[k] ? arrayDownloadableFilesButtonTexts[k] : "Descarga fichero " + extensionFile.toUpperCase() 
        })
      }

      setFilePathDownload(newArrayFilesData);
    }

    const finalHtml = content ? content : content2;
    if (finalHtml){
      if (rootMultimedia.length > 0){
        if(artPlayerInstances.length > 0) {
          for (let k = 0; k < artPlayerInstances.length; k++){
            artPlayerInstances[k].destroy();
          }
        }

        if(audiosInstances.length > 0) {
          for (let k = 0; k < audiosInstances.length; k++){
            audiosInstances[k] = null;
          }
        }

        for (let i = 0; i < rootMultimedia.length; i++){
          try{
            rootMultimedia[i].unmount();
          }catch(e){
            console.log(e)
          }
          
        }
        setRootMultimedia([], (prevValue, newValue) => {
          console.log(newValue);
          setArtPlayerInstances([]);
          const content = document.querySelectorAll('[data-art-id]');
          if (content && content.length && content.length > 0) {
            for (let i = 0; i < content.length; i++) {
              content[i].parentElement?.remove();
            }
          }

          setHtml(finalHtml);
        })
      }else{
        setHtml(finalHtml);
      }
    }else{
      setHtml(null);
    }
  };

  const renderMultimediaComponents = async () => {
    const videos = data.videos ? data.videos.split(',') : null;
    const audios = data.audios ? data.audios.split(',') : null;
    const iframe = data.interactivos ? data.interactivos.split(',') : null;
    const videosSubtitle = data.subtitulos_videos ? data.subtitulos_videos.split(',') : null;
    console.log(videosSubtitle)
    let path = "cursos/" + courseCode;
    if (Array.isArray(videos)) {
      for (let i = 0; i < videos.length; i++) {
        const finalPath = await getPathCourseResource(
          path + '/videos/' + data.cod_unidad + "/" + videos[i]
        );
        let subtitlePath = ""
        if (videosSubtitle && Array.isArray(videosSubtitle)) {
          const subtititlesAr = videosSubtitle.filter(ele => ele.split(".")[0] == videos[i].split(".")[0])
          if (subtititlesAr.length > 0) {
            subtitlePath = await getPathCourseResource(
              path + '/videos/' + data.cod_unidad + "/" + subtititlesAr[0]
            );
          }
        }
        await renderMultimedia(videos[i], 'VIDEO', finalPath, data.nombre, subtitlePath);
      }
    }

    if (Array.isArray(audios)) {
      for (let i = 0; i < audios.length; i++) {
        const finalPath = await getPathCourseResource(
          path + '/audios/' + audios[i]
        );
        console.log(finalPath)
        await renderMultimedia(audios[i], 'AUDIO', finalPath, data.nombre);
      }
    }

    if (Array.isArray(iframe)) {
      for (let i = 0; i < iframe.length; i++){
        const finalPath = await getPathCourseResource(
          path + '/interactivos/' + data.cod_unidad + "/" + iframe[i]  + "/index.html"
        );
        await renderMultimedia("iframe_" + iframe[i], 'IFRAME', finalPath, data.nombre);
      }
    }
  };

  const updateIsPlayingValue = (value) => {
    setPlaying(value)
  }

  const updateVideosDuration = (value) => {
   videosDuration.current = videosDuration.current + value;
  }

  const renderMultimedia = (identifier, type, source, name, subtitle = "") => {
    const container = document.getElementById(identifier);
    if (container && container.innerHTML) {
      container.innerHTML = container.innerHTML.trim();
    }
    const root = createRoot(container);
    setRootMultimedia(Array.from(rootMultimedia).concat([root]), (prevValue, newValue) => {
      console.log(newValue);
    })
    let component = null;
    switch (type) {
      case 'AUDIO':
        const playList = [
          {
            name: name,
            //writer: 'writer',
            //img: '',
            src: source,
            id: 1
          },
        ];
        component = <Audio playList={playList} getInstance={(audioInstance)=>{
          
          audioInstance.id = identifier + "_audio";
          const audioElement = document.getElementById(audioInstance.id)
          audioElement.onplay = function() {
            const isSaved1 = document.getElementById("input-hidden-saved").value == "true";
            if (!isSaved1) {
              updateIsPlayingValue(true);
            }
          };
          audioElement.onpause = function() {
            updateIsPlayingValue(false);
          };

          audioElement.onloadeddata = function () {
            console.log(audioElement.duration)
            audiosDuration.current = audiosDuration.current + audioElement.duration
          }

          setAudiosInstances(audiosInstances => [...audiosInstances, audioInstance])

         }} />;
      break;

      case 'VIDEO':
        component = <Video source={source} subtitle={subtitle} getInstance={(artInstance)=>{

          artInstance.on('video:canplay', (...args) => {
            if (data.duracion_minima_segundos == null) {
              const el = document.querySelector('[data-art-id="'+artInstance.id+'"]');
              if (el) {
                const video = el.querySelector("video");
                updateVideosDuration(video.duration);
              }
            }
          });

          artInstance.on('video:play', (...args) => {
            const inputHidden = document.getElementById("input-hidden-saved");
            if (inputHidden) {
              const isSaved1 = document.getElementById("input-hidden-saved").value == "true";
              if (!isSaved1){
                updateIsPlayingValue(true);
              }
            }
          });
          artInstance.on('video:pause', (...args) => {

              updateIsPlayingValue(false);
            
          });
          

          artInstance.on("video:timeupdate", (...args) => {
            console.log(artInstance.currentTime)
            const inputHidden = document.getElementById("input-hidden-saved");
            if (inputHidden) {
              const isSaved2 = document.getElementById("input-hidden-saved").value == "true";
              const isPlaying2 = document.getElementById("input-hidden-is-playing").value == "true";
              if (!isPlaying2 && !isSaved2) {
                updateIsPlayingValue(true);
              }
            }
            
          });

          setArtPlayerInstances(artPlayerInstances => [...artPlayerInstances, artInstance])
        }} />;
      break;

      case 'IFRAME':
        component = <ResponsiveIframe id={identifier} sourceUrl={source} title={""} callbackSave={()=>{
          if (isQuizFinalized.current == false){
            isQuizFinalized.current = true;
            setPlaying(false);
            setCount(0);
            insertView()
          }
        }} />
      break;
    }

    root.render(component);
  };

  const insertView = async() => {
    const userId = authState && authState.user ? authState.user.email : "test";
    if(type == "SUBLESSON"){
      const request = await HttpClient().post(`/lessons/save-sublesson/${userId}/${data.id}`, {
        
      })
      console.log(request)
      console.log("guardado...")
      setIsSaved(true);
      onFinalize();
    }

    if(type == "LESSON" && data.operativa == 1){
      console.log("guardado...")
      const request = await HttpClient().post(`/lessons/save-lesson/${userId}/${data.cod_leccion}`, {
        
      })
      console.log(request)
      setIsSaved(true);
      onFinalize();
    }
  }

  const downloadFile = async(filePath) => {
    setOpen(true);
    try {
      const fileBytes = await getBinaryContent(filePath);
      const filePathAr = filePath.split("/");
      const fileName =  filePathAr[filePathAr.length - 1];
      const extension = filePathAr[filePathAr.length - 1].split(".").pop();
      console.log(fileName, getMimeType(extension))
      fileDownload(fileBytes, fileName);
      //download(fileBytes, fileName, getMimeType(extension));
    }catch(e) {
      showToast("No se pudo descargar el archivo. Intenta nuevamente.", "error")
    }
    
    setOpen(false);
  }

  useEffect(() => {
    setOpen(true);
    if (data && data.tipo && data.tipo == "EV") {
      isQuizFinalized.current = false;
    }else{
      isQuizFinalized.current = true;
    }
    durationFromDB.current = false;
    prepareHtml();
    setOpen(false);
  }, [data]);

  useEffect(() => {
    setIsSaved(false);
    setPlaying(false);
    setCount(0);
    if (html) {
      videosDuration.current = 0;
      audiosDuration.current = 0;
      renderMultimediaComponents();
      document.getElementsByClassName("main")[0].scrollTo({ top: 0, left: 0 });
      const videos = data.videos ? data.videos.split(',') : null;
      const audios = data.audios ? data.audios.split(',') : null;
      if (!videos && !audios) {
        if (types.includes(type)){
          setPlaying(true);
        }
      }
    }
  }, [html]);


  useEffect(()=>{
    if (count > 0) {
      console.log(count)
      let readyTimeVideos = true;
      let readyTimeAudios = true;
      let readyTimeOther = true;
      if (durationFromDB.current == false){
        if (artPlayerInstances.length > 0 && videosDuration.current > 0) {
          const currentPercentVideos = ((count * 100) / videosDuration.current)
          if (currentPercentVideos < MAX_DURATION_VIDEOS_PERCENTAGE ||  count > videosDuration.current) {
            readyTimeVideos = false;
          }
        }
  
        if (audiosDuration.current > 0) {
          const currentPercentAudios = ((count * 100) / audiosDuration.current)
          if (currentPercentAudios < MAX_DURATION_AUDIOS_PERCENTAGE ||  count > audiosDuration.current) {
            readyTimeAudios = false;
          }
        }
  
        if (artPlayerInstances.length == 0 && audiosDuration.current == 0) {
          if ((count < sublessonDuration.current || !isQuizFinalized.current) ||  count > sublessonDuration.current) {
            readyTimeOther = false;
          } 
        }
      }else{
        if ((count < sublessonDuration.current || !isQuizFinalized.current) ||  count > sublessonDuration.current) {
          readyTimeOther = false;
        } 
      }
      

      if (readyTimeVideos == true &&
        readyTimeAudios == true &&
        readyTimeOther == true) {
          setPlaying(false);
          setCount(0);
          insertView();
        }
    }
  }, [count])

  return (
    <Grid container columns={{ xs: 4, md: 12 }} spacing={2}>
      <OverlayLoader open={open} />
      <Grid item xs={12}>
        {html ? <div className="mt-content">{parse(html)}</div> : null}
      </Grid>
      { data && filePathDownload && filePathDownload.map(function(file) {
        return (
          <Grid item xs={12} className="download-button-container">
            <Button onClick={async()=>{
              await downloadFile(file.file);
            }} variant="outlined" download>{file.buttonText}</Button>
          </Grid>
        )
      })}
    
      <Grid item xs={12} className="lessons-button-container-center">
        <ButtomCustom onClick={()=>{
         onContinue()
        }} variant="contained" rounded>
          Continuar
        </ButtomCustom>
      </Grid>
      <input type={"hidden"} value={isSaved} id={"input-hidden-saved"} />
      <input type={"hidden"} value={isPlaying} id={"input-hidden-is-playing"} />
      {/*<ToastContainer limit={3} autoClose={3000} />*/}
    </Grid>
  );
};

export default ContentRenderer;
